import { withSvgIcon } from './withSvgIcon';

export const Chart = withSvgIcon(
  <>
    <rect
      x="4"
      y="8"
      width="4"
      height="12"
      rx="1"
      stroke="currentColor"
      strokeWidth="2"
    />
    <rect
      x="12"
      y="12"
      width="4"
      height="8"
      rx="1"
      stroke="currentColor"
      strokeWidth="2"
    />
    <rect
      x="20"
      y="4"
      width="4"
      height="16"
      rx="1"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M3 24H25" stroke="currentColor" strokeWidth="2" />
  </>,
  { viewBox: '0 0 28 28' },
);
